<template>
	<nuxt-link
		class="news-card"
		:class="{ 'news-card--card': card }"
		:to="localePath({ name: 'news-newsID-newsTitle', params: { newsID: post.id, newsTitle: newsService.getNewsName(post.title) } })">
		<div class="news-card__content">
			<div class="news-card__image-container">
				<GlobalImage v-if="topImage" class="news-card__image" :alt="post.title" :src="storageUrl + topImage" :height="220" />
				<GlobalImage v-else class="news-card__image" src="news_placeholder.png" alt="News placeholder" :height="220" />
			</div>
			<div class="news-card__date-and-title">
				<div class="news-card__date">{{ format(new Date(post.createdAt), 'dd.MM.yyyy') }}</div>
				<div class="news-card__title">{{ post.title }}</div>
			</div>
		</div>
	</nuxt-link>
</template>

<script setup lang="ts">
import { format } from 'date-fns'
const localePath = useLocalePath()
const newsService = useNewsService()
const { storageUrl } = useStorageService()

const props = defineProps<{
	post: Partial<INewsModel>
	card?: boolean
}>()

const topImage = computed(() => {
	const file = props.post.files?.find((f) => f.collection === EFileCollection.NEWS_TOP_IMAGE)
	return file ? file.path : null
})
</script>

<style lang="scss">
@import './Card.scss';
</style>
